// Sursa clientului (prima pagina din vizita), folosita doar pentru Analitice in admin.
// Se tine in sessionStorage (NU cookie) si se trimite doar odata cu comanda.
// Fara date personale: doar sursa, mediul, campania, domeniul de provenienta si calea paginii.

const KEY = 'order_attribution';

const SEARCH = [
  ['gemini.google.', 'gemini', 'ai'],
  ['google.', 'google', 'organic'],
  ['bing.', 'bing', 'organic'],
  ['duckduckgo.', 'duckduckgo', 'organic'],
  ['yahoo.', 'yahoo', 'organic'],
  ['ecosia.', 'ecosia', 'organic'],
  ['chatgpt.com', 'chatgpt', 'ai'],
  ['chat.openai.com', 'chatgpt', 'ai'],
  ['perplexity.', 'perplexity', 'ai'],
  ['copilot.microsoft.', 'copilot', 'ai'],
  ['claude.ai', 'claude', 'ai'],
  ['facebook.', 'facebook', 'social'],
  ['instagram.', 'instagram', 'social'],
  ['linkedin.', 'linkedin', 'social']
];

const cut = (v) => (typeof v === 'string' ? v.trim().slice(0, 200) : '');

export const captureAttribution = () => {
  try {
    if (typeof window === 'undefined' || sessionStorage.getItem(KEY)) return;
    const path = window.location.pathname;
    if (path.startsWith('/admin') || path.startsWith('/payment')) return;

    const params = new URLSearchParams(window.location.search);
    let host = '';
    try {
      host = document.referrer ? new URL(document.referrer).hostname.toLowerCase() : '';
    } catch (e) {}
    if (host.endsWith('constatatoare.ro')) host = '';

    const data = { landingPage: cut(path) };
    if (host) data.referrer = host;

    const utmSource = cut(params.get('utm_source'));
    if (utmSource) {
      data.source = utmSource;
      data.medium = cut(params.get('utm_medium')) || '(none)';
      const campaign = cut(params.get('utm_campaign'));
      if (campaign) data.campaign = campaign;
    } else if (host) {
      const match = SEARCH.find(([needle]) => host.includes(needle));
      data.source = match ? match[1] : host.replace(/^www\./, '');
      data.medium = match ? match[2] : 'referral';
    } else {
      data.source = '(direct)';
      data.medium = '(none)';
    }

    sessionStorage.setItem(KEY, JSON.stringify(data));
  } catch (e) {
    // analiticele nu au voie sa afecteze site-ul
  }
};

export const getAttribution = () => {
  try {
    const raw = sessionStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : undefined;
  } catch (e) {
    return undefined;
  }
};
